import { CheckoutMapComponent, ParentState } from "@hopper-b2b/checkout";

import { BookingConfirmation } from "./BookingConfirmation";
import { CartFulfillComponent } from "./CartFulfillComponent";
import { CartQuoteComponent } from "./CartQuoteComponent";
import { CartUpdateComponent } from "./CartUpdateComponent";
import { ConnectedContactInformation as ContactInformation } from "./ContactInformation";
import { LoadingScreen } from "./LoadingScreen";
import { ConnectedPassengerInformation as PassengerInformation } from "./PassengerInformation";
import { PassportInformation } from "./PassportInformation";
import { PaymentLoader } from "./PaymentLoader/component";
import { ConnectedReviewComponent as ReviewComponent } from "./Review";
import { ConnectedSeatSelection as SeatSelection } from "./SeatSelection";

export const flightComponentMap = {
  [ParentState.priceFreeze]: {
    state: ParentState.priceFreeze,
    component: LoadingScreen,
  },
  [ParentState.loading]: {
    state: ParentState.loading,
    component: LoadingScreen,
  },
  [ParentState.contactInformation]: {
    state: ParentState.contactInformation,
    component: ContactInformation,
  },
  [ParentState.passengerInformation]: {
    state: ParentState.passengerInformation,
    component: PassengerInformation,
  },
  [ParentState.passport]: {
    state: ParentState.passport,
    component: PassportInformation,
  },
  [ParentState.cartQuote]: {
    state: ParentState.cartQuote,
    component: CartQuoteComponent,
  },
  [ParentState.cancelForAnyReason]: {
    state: ParentState.cancelForAnyReason,
    component: LoadingScreen,
  },
  [ParentState.priceFreezeDiscount]: {
    state: ParentState.priceFreezeDiscount,
    component: LoadingScreen,
  },
  [ParentState.disruption]: {
    state: ParentState.disruption,
    component: LoadingScreen,
  },
  [ParentState.cartUpdate]: {
    state: ParentState.cartUpdate,
    component: CartUpdateComponent,
  },
  [ParentState.seatSelection]: {
    state: ParentState.seatSelection,
    component: SeatSelection,
  },
  [ParentState.review]: {
    state: ParentState.review,
    component: ReviewComponent,
  },
  [ParentState.cartUpdateBeforeFulfill]: {
    state: ParentState.cartUpdateBeforeFulfill,
    component: CartUpdateComponent,
  },
  [ParentState.payment]: {
    state: ParentState.payment,
    component: PaymentLoader,
  },
  [ParentState.cartFulfill]: {
    state: ParentState.cartFulfill,
    component: CartFulfillComponent,
  },
  [ParentState.bookingConfirmation]: {
    state: ParentState.bookingConfirmation,
    component: BookingConfirmation,
  },
};

export const FlightCheckoutComponent = () => {
  return <CheckoutMapComponent componentMap={flightComponentMap} />;
};
